<template>
  <v-snackbar
      :width="width"
      :value="state"
      :timeout="timeout"
      transition="slide-y-reverse-transition"
      @input="close"
  >
    <div class="content">
      <div
          class="content__text"
      >
        {{ text }}
      </div>
      <slot></slot>
      <div class="content__actions">
        <m-button
            v-if="useAction"
            :text="actionButtonText"
            color="blue"
            @click="action"
        >

        </m-button>

        <v-icon @click="close" color="white" size="16">
          $cross
        </v-icon>
      </div>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: 'm-snackbar',
  props: {
    width: {
      Type: Number,
      Default: 200
    },
    state: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    timeout: {
      type: Number,
      default: -1,
    },
    useAction: {
      type: Boolean,
      default: false
    },
    actionButtonText: {
      type: String,
      default: '',
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    action() {
      this.$emit('action')

      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 5px;

  &__text {
    color: white;
    font-size: 15px;
  }

  &__actions {
    display: flex;
    flex-wrap: nowrap;
  }
}

</style>
